import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort, MatPaginatorIntl, Sort, PageEvent } from '@angular/material';
import { ParComplaintsTimelineService } from '../../services/par-complaints-timeline/par-complaints-timeline.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { AgentlocationService } from '../../services/agent_location/agentlocation.service';
@Component({
  selector: 'app-manage-complaint-timeline-dialog',
  templateUrl: './manage-complaint-timeline-dialog.component.html',
  styleUrls: ['./manage-complaint-timeline-dialog.component.css']
})

export class ManageComplaintTimelineDialogComponent implements OnInit {
  dataSource: MatTableDataSource<ViewTimelineData>;
  // dataSource = [];
  data = {
    ComplaintSource: '',
    DebtorFirstName: '',
    DebtorLastName: '',
    MasterVendorName: '',
    ResolutionDate: '',
    Controllable: '',
    ComplaintType: '',
    ClientName: '',
    Users: '',
    VendorLocation: '',
    ResolutionType: '',
    Completed: false
  };

  errorMessage: string = '';
  errorEnable: boolean = false;
  displayedColumns = ['TransactionType', 'UploadedOn', 'UploadedBy'];
  timelineData: any;
  transactionList: any;
  ispaginationFlag: boolean = false;
  message: string;
  private subscription: Subscription;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  length: any;
  pageEvent: PageEvent;
  pageSize = 10;
  public typeErr: boolean = false;
  public errMsg: any;
  makeReadOnly: boolean = true;

  constructor(public dialogRef: MatDialogRef<ManageComplaintTimelineDialogComponent>,
    public parComplaintsTimelineService: ParComplaintsTimelineService,
    public agentLocationService: AgentlocationService,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public complaintsData: any) { }

  ngOnInit() {
    this.getTimeline();
    this.getTimelineTable(this.complaintsData.complaintData.ComplaintId);
    this.agentLocationService.locationDetsOfAgent(this.complaintsData.complaintData.VendorLocationId, this.complaintsData.complaintData.MasterVendorId).subscribe(res => {
      if (res) {
        if (res.vendorLocationDetails[0].Address1)
          this.data.VendorLocation = res.vendorLocationDetails[0].Address1;
        if (res.vendorLocationDetails[0].Address2)
          this.data.VendorLocation = this.data.VendorLocation + " " + res.vendorLocationDetails[0].Address2;
        if (res.vendorLocationDetails[0].City)
          this.data.VendorLocation = this.data.VendorLocation + "," + res.vendorLocationDetails[0].City;
        if (res.vendorLocationDetails[0].State)
          this.data.VendorLocation = this.data.VendorLocation + "," + res.vendorLocationDetails[0].State;
        if (res.vendorLocationDetails[0].PostalCode)
          this.data.VendorLocation = this.data.VendorLocation + "-" + res.vendorLocationDetails[0].PostalCode;
      } else {
        this.data.VendorLocation = "";
      }
    }, err => {
      this.errMsg = "Location Service Error in timeline" + err;
      this.typeErr = true;
    });
  }


  onNoClick() {
    this.dialogRef.close();
  }

  getTimeline() {
    this.data.ComplaintSource = this.complaintsData.complaintData.ComplaintSource;
    this.data.DebtorFirstName = this.complaintsData.complaintData.FirstName;
    this.data.DebtorLastName = this.complaintsData.complaintData.LastName;
    this.data.MasterVendorName = this.complaintsData.complaintData.MasterVendorName;
    this.data.ResolutionDate = (this.complaintsData.complaintData.ResolutionDate == '') ? '' : moment(this.complaintsData.complaintData.ResolutionDate).format('MM/DD/YYYY');
    this.data.Controllable = this.complaintsData.complaintData.Controllable;
    this.data.ComplaintType = this.complaintsData.complaintData.ComplaintType;
    this.data.ClientName = this.complaintsData.complaintData.ClientName;
    this.data.Users = this.complaintsData.complaintData.UserName;
    this.data.VendorLocation = this.complaintsData.complaintData.VendorLocation;
    this.data.ResolutionType = this.complaintsData.complaintData.Resolution;
    this.getCompleted(this.complaintsData.complaintData.ComplaintStatus)
  }

  getTimelineTable(complaintId) {
    this.parComplaintsTimelineService.getTimelineTableData(complaintId).subscribe(res => {
      if (!res.Transactions) {
        this.transactionList = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.message = "No Transactions Data is available for the Complaint";
      } else {
        this.message = '';
        this.transactionList = res.Transactions;
        for (let i = 0; i < this.transactionList.length; i++) {
          if (this.transactionList[i].CreatedTimeStamp) {
            this.transactionList[i].CreatedTimeStamp = moment(this.transactionList[i].CreatedTimeStamp).format('MM/DD/YYYY');
          }
        }

        this.dataSource = new MatTableDataSource(this.transactionList);
        this.dataSource.sort = this.sort;
        this.length = this.transactionList.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        } else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) {
            return `0 van ${length}`;
          }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        };
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, err => {
      this.errorMessage = "View Timeline Service : " + err;
      this.errorEnable = true;
    });

  }

  getCompleted(complaintStatus) {
    if (complaintStatus == 1) {
      this.data.Completed = true;
    } else {
      this.data.Completed = false;
    }
  }

}

export interface ViewTimelineData {
  TransactionType: String;
  CreatedTimeStamp: Date;
  CreatedBy: String;
}



// WEBPACK FOOTER //
// ./src/app/components/manage-complaint-timeline-dialog/manage-complaint-timeline-dialog.component.ts